import { ACTION_TYPES } from './step.actions';
import { StepState, initialState, initialStepActions } from './step.state';

export default (state: StepState = initialState, action): StepState => {
  switch (action.type) {
    case ACTION_TYPES.UPDATE_STEP:
      return {
        ...state,
        previousStep: action.payload.previousStep,
        currentStep: action.payload.currentStep,
        showPreviousButton: false,
        showNextButton: false
      };

    case ACTION_TYPES.SET_STEPS_ACTIONS:
      return {
        ...state,
        ...initialStepActions,
        ...action.payload
      };
    case ACTION_TYPES.SET_ACTION_BEFORE_PREVIOUS_STEP:
      return {
        ...state,

        actionBeforePreviousStep: action.payload.actionBeforePreviousStep
      };
    case ACTION_TYPES.SET_ACTION_BEFORE_NEXT_STEP:
      return {
        ...state,
        actionBeforeNextStep: action.payload.actionBeforeNextStep
      };
    case ACTION_TYPES.TOGGLE_PREVIOUS_BUTTON:
      return {
        ...state,
        showPreviousButton: action.payload.showPreviousButton
      };
    case ACTION_TYPES.SET_PREVIOUS_BUTTON_LABEL:
      return {
        ...state,
        previousButtonLabel: action.payload.previousButtonLabel
      };
    case ACTION_TYPES.TOGGLE_NEXT_BUTTON:
      return {
        ...state,
        showNextButton: action.payload.showNextButton
      };
    case ACTION_TYPES.SET_NEXT_BUTTON_LABEL:
      return {
        ...state,
        nextButtonLabel: action.payload.nextButtonLabel
      };
    case ACTION_TYPES.SET_PREVIOUS_NEXT_BUTTON_LABEL:
      return {
        ...state,
        previousButtonLabel: action.payload.previousButtonLabel,
        nextButtonLabel: action.payload.nextButtonLabel
      };
    case ACTION_TYPES.TOGGLE_PREVIOUS_NEXT_BUTTON:
      return {
        ...state,
        showPreviousButton: action.payload.showPreviousButton,
        showNextButton: action.payload.showNextButton
      };
    case ACTION_TYPES.DISABLE_BUTTONS:
      return {
        ...state,
        disableButtons: action.payload.disableButtons
      };
    case ACTION_TYPES.DISABLE_PREVIOUS_BUTTON:
      return {
        ...state,
        disablePreviousButton: action.payload.disablePreviousButton
      };
    case ACTION_TYPES.DISABLE_NEXT_BUTTON:
      return {
        ...state,
        disableNextButton: action.payload.disableNextButton
      };
    case ACTION_TYPES.HIDE_BUTTONS:
      return {
        ...state,
        showPreviousButton: false,
        showNextButton: false
      };
    case ACTION_TYPES.SET_FORM:
      return {
        ...state,
        form: action.payload.form
      };
    case ACTION_TYPES.SET_FULL_SIZE:
      return {
        ...state,
        fullSize: action.payload.fullSize
      };
    case ACTION_TYPES.SET_JOURNEY_STEPS:
      return {
        ...state,
        journeyStepsList: [...action.payload.journeyStepsList],
        journeySteps: { ...state.journeySteps, ...action.payload.journeySteps },
        isLoaded: true
      };

    case ACTION_TYPES.SET_STEP_MESSAGE:
      return {
        ...state,
        title: action.payload.title,
        subTitles: action.payload.subTitles
      };
    case ACTION_TYPES.SET_STEP_TITLE:
      return {
        ...state,
        title: action.payload.title
      };
    case ACTION_TYPES.SET_STEP_SUB_TITLE:
      return {
        ...state,
        subTitles: action.payload.subTitles
      };
    case ACTION_TYPES.SET_ERROR:
      return {
        ...state,
        errorJourney: action.payload
      };
    case ACTION_TYPES.RESET_ERROR:
      return {
        ...state,
        errorJourney: null
      };
    case ACTION_TYPES.SET_STEPS_LOADED:
      return {
        ...state,
        stepsLoaded: true
      };

    default:
      return state;
  }
};
